<template>
  <div id="RegisterUser" class="container scale-transition scale-in">
    <div class="row">
      <div class="col s12 m12 l12 xl12">
        <div class="card border_card">
          <div class="card-image img-movil"></div>
          <div class="card-content text-content">
            <strong class="line-thru">
              <span>Registrase con</span>
            </strong>
            <div class="row">
              <div class="col s12 m12 l12 xl12 center">
                <a class="waves-effect waves-light blue-grey lighten-5 black-text btn-small">
                  <i class="fa fa-google left"></i> Google
                </a>
                <a class="waves-effect waves-light blue darken-4 btn-small">
                  <i class="fa fa-facebook left"></i> Facebook
                </a>
              </div>
            </div>
            <br>
            <strong class="line-thru">o
              <br>
              <span>Con tu correo personal</span>
            </strong>
            <form class="s12 m12 xl12" @submit.prevent="sendMail">
              <div class="row">
                <div class="input-field col s12 m12 l6 xl6">
                  <i class="material-icons hide-on-small-only">account_circle</i>
                  <input
                    v-model="form.first_name"
                    placeholder="Digite Sus Nombres"
                    id="first_name"
                    type="text"
                    class="validate"
                    required
                  >
                  <label for="first_name">Nombres</label>
                  <span
                    class="helper-text"
                    data-error="El Nombre es obligatorio"
                    data-success="Nombre OK!"
                  >Mensaje de Ayuda</span>
                </div>
                <div class="input-field col s12 m12 l6 xl6">
                  <i class="material-icons hide-on-small-only">account_circle</i>
                  <input
                    v-model="form.last_name"
                    placeholder="Digite Sus Apellidos"
                    id="last_name"
                    type="text"
                    class="validate"
                  >
                  <label for="last_name">Apellidos</label>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12 m12 l6 xl6">
                  <i class="material-icons hide-on-small-only">email</i>
                  <input
                    placeholder="Digite sus correo electronico"
                    id="email"
                    v-model="form.email"
                    type="email"
                    class="validate"
                    autocomplete="nope"
                    required
                  >
                  <label for="email">Correo Electronico</label>
                  <span
                    class="helper-text"
                    data-error="Correo Electronico no Valido"
                    data-success="Correo Electronico OK!"
                  >Mensaje de Ayuda</span>
                </div>
                <div class="input-field col s12 m12 l6 xl6">
                  <i class="material-icons hide-on-small-only">vpn_key</i>
                  <input
                    v-model="form.password"
                    minlength="8"
                    id="password"
                    type="password"
                    class="validate"
                    autocomplete="new-password"
                    required
                  >
                  <label for="password">Contraseña</label>
                  <span
                    class="helper-text"
                    data-error="La Contraseña debe ser minimo de 8 caracteres"
                    data-success="Contraseña OK!"
                  >Mensaje de Ayuda</span>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12 m12 xl12 center">
                  <router-link
                    v-bind:to="{name:'SearchCatering'}"
                    class="btn-small waves-effect waves-light btn waves-effect waves-light red darken-4"
                  >
                    Buscar Catering
                    <i class="material-icons left">search</i>
                  </router-link>
                  <br>
                  <span>¿Ya tienes una cuenta? Iniciar sesión</span>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RegisterUser",
  data() {
    return {
      form: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        password: null
      }
    };
  },
  methods: {
    sendMail() {}
  }
};
</script>

<style scoped lang="css">
.container {
  width: 95% !important;
  text-align: center;
}
.row {
  margin-bottom: 0px !important;
}
.row .col {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 0 0 0 !important;
  min-height: 1px;
}

.border_card {
  border-radius: 20px !important;
}
.card .img-movil img {
  width: 200px !important;
}

.input-field {
  margin-top: 1rem !important;
  margin-bottom: 0rem !important;
}
</style>


// WEBPACK FOOTER //
// src/components/users/RegisterUser.vue